"use strict";
exports.__esModule = true;
exports.rust = void 0;
var client_1 = require("./reqwest/client");
exports.rust = {
    info: {
        key: 'rust',
        title: 'Rust',
        extname: '.rs',
        "default": 'reqwest'
    },
    clientsById: {
        reqwest: client_1.reqwest
    }
};
//# sourceMappingURL=target.js.map